var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cartItem"},[_c('i',{class:_vm.removeIcon,on:{"click":function($event){$event.preventDefault();return _vm.remove.apply(null, arguments)}}}),_c('div',{staticClass:"item"},[_vm._v(_vm._s(_vm.item.qty)+" Stück(e): "+_vm._s(_vm.item.name))]),_vm._v(" "),_c('div',{staticClass:"clear"})])
}
var staticRenderFns = []

export { render, staticRenderFns }